"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JANGLE_RADIANS = exports.JANGLE_DEGREES = void 0;
exports.JANGLE_DEGREES = 27;
exports.JANGLE_RADIANS = exports.JANGLE_DEGREES * Math.PI / 180;
